module.exports = __webpack_public_path__ + "vue-assets/img/logo-sm.6f9190a7.svg";